import React, {useEffect, useState} from "react";
import Fade from '@material-ui/core/Fade';
import ReviewCardPopUp from "./card/ReviewCardPopUp";
import {Box} from "@material-ui/core";

export default function PopUpWidget(props) {
    const {seat_id, apiUrl,showTime = 5,waitTime = 20,startTime = 5,footer,logo,profilePic} = props;

    const [reviews, setReview] = useState([])
    const [currentReview, setCurrentReview] = useState(0)
    const [show, setShow] = useState(false)
    const step = 6
    const [n] = useState(step)

    //get aviable integrations
    useEffect(() => {

        const loopReviews = (time, maxLen) => {
            setTimeout(() => {
                let checkv = null
                setShow(show => {
                    if (checkv === null) {
                        checkv = show
                        if (show === false) {
                            // 0 = infinite
                            if(showTime > 0) {
                                loopReviews(showTime * 1000, maxLen)
                            }
                            return true
                        }
                        if (show === true) {
                            loopReviews(waitTime * 1000, maxLen)
                            setTimeout(() => {
                                setCurrentReview(v => {
                                    if (v === maxLen) {
                                        return 0
                                    } else {
                                        return v + 1
                                    }
                                })
                            },(waitTime * 1000) / 2)
                            return false
                        }
                    } else {
                        return !show
                    }
                })
            }, time)
        }

        if (seat_id)
            fetch(`${apiUrl}/seats/${seat_id}/reviews/widgets?n=${n}`, {
                method: "GET",
            }).then(async (body) => {
                if (body.ok) {
                    let data = await body.json()
                    setReview(data.reviews)
                    loopReviews(startTime * 1000, data.reviews.length - 1)
                }
            })
                .catch(err => console.error(err))
    }, [apiUrl, n, seat_id,showTime,waitTime,startTime]);

    return (
        <React.Fragment>
            {
                reviews.length > 0 ?
                    <Fade in={show}>
                        <Box p={3} width={'100%'} key={currentReview} data-iframe-height data-iframe-width>
                            <ReviewCardPopUp review={reviews[currentReview]} footer={footer} logo={logo} profilePic={profilePic}/>
                        </Box>
                    </Fade> : null
            }
        </React.Fragment>
    )
}
